export const blockIconsPrivacyandsecurityEncryptedNew = (
	<span className='material-symbols-outlined'>encrypted</span>
);
